var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sentence"},[_c('h1',[_vm._v(" A Catalyst at the Intersection of "),_c('span',{class:['changing-word', { 'fade-out': _vm.isAnimating }]},[_vm._v(_vm._s(_vm.currentWord))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }